import { createQueryKeys } from "@lukemorales/query-key-factory";
import axios from "axios";
import { BidsApi } from "mws-ts-v2-sdk";

const getBidsApi = () => {
  return new BidsApi(
    undefined,
    useRuntimeConfig().public.catalogServiceUrl,
    axios,
  );
};

export const bidCostsQueryKeys = createQueryKeys("bidCosts", {
  details: (
    platformId: MaybeRef<string>,
    filters: MaybeRef<{
      productId: string;
      bid?: number;
      currency: string;
      destinationCountryCode?: string;
      userId?: string;
    }>,
  ) => ({
    queryKey: [filters],
    queryFn: async () => {
      const unreffedFilters = unref(filters);
      // Note: userId is extracted from filters but not sent to the API.
      // It is used only for query invalidation purposes (as part of the query key).
      const { userId, ...apiFilters } = unreffedFilters;

      const response = await getBidsApi().v2BidCostsGet({
        xPlatformKey: unref(platformId),
        ...apiFilters,
      });

      return response.data;
    },
  }),
});
